import React, { Component } from 'react';
import {
    Form, Radio, Button, Container, Progress,
    Header, Icon, Message, Image, Grid, Modal,
} from 'semantic-ui-react';
import { Route, Switch, Link } from 'react-router-dom';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export function LandingPageModal(props) {
    return (

        
        <Modal
            //trigger={<Button onClick={props.handleOpen}>Show Modal</Button>}
            open={props.modalOpen}
            onClose={props.handleClose}
            basic
            size='small'>

            <Header icon='browser' content='Print Boda' />
            <Modal.Content>
                <h3> coming Soon! You can order a custom t-shirt for now!</h3>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' onClick={props.handleClose} inverted>
                    <Icon name='checkmark' /> Got it
            </Button>
            </Modal.Actions>
        </Modal>
    )
}

/**
 * DISPLAYS WHEN ORDER IS COMPLETE
 * @param {*} props 
 */
export function OrderComplete(props) {

    
    //T-SHIRTS
    const t_shirtLeadTime = props.newOrderObject.itemType === 't-shirts'
        ? (
            <Header.Subheader>
                You can expect your t-shirts in 5-7 working days after approval your design and receipt of deposit.
          </Header.Subheader>
        )
        : ''

    //CRANES OR FOOTBALL
    const jerseyLeadTime = props.newOrderObject.itemType === 'football' || props.newOrderObject.itemType === 'cranes'
        ? (
            <Header.Subheader>
                You can expect your jersey in 5-7 working days after receipt of deposit.
          </Header.Subheader>
        )
        : ''

    //T-SHIRTS
    const jumperLeadTime = props.newOrderObject.itemType === 'jumper'
        ? (
            <Header.Subheader>
                You can expect your jumper in 5-7 working days after approving your design and receipt of deposit..
            </Header.Subheader>
        )
        : ''

    return (
        props.orderComplete
            ? 
        <div>
            <Grid
                textAlign='center'
                style={{ height: '100%' }}
                verticalAlign='middle'
            >
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' color='blue' textAlign='center'>
                        {' '} Order Complete!
                    <Header.Subheader>
                            Thank you for placing your order.
                    </Header.Subheader>

                        {t_shirtLeadTime}

                        {jerseyLeadTime}

                        {jumperLeadTime}


                        <br />
                        {' '} Deposit Policy
                    <Header.Subheader>
                            We can't wait to begin on your order! However, as we are going to make a one of a kind customized item just for you
                        we  require a 50% deposit of before we can complete your order.
                    </Header.Subheader>
                        <br />
                        <Header.Subheader>
                            You can send your deposit to 0788 106 400 (name - Printboda Limited) OR 0757 477 399 (name - Rhoda). {'\n'}Reason: Order {props.orderNum}
                            
                    </Header.Subheader>
                        <br />
                        <Header.Subheader>
                            You can reach us at 0757 477 399 with any questions or check out our facebook page:
                            <a href={"https://www.facebook.com/PrintBodaUg"}>https://www.facebook.com/PrintBodaUg</a> 
                    </Header.Subheader>
                        <Header.Subheader>
                            <br />
                            <Button massive color='green' onClick={() => history.push('/')}>
                                HOME
                        </Button>
                        </Header.Subheader>

                    </Header>
                    <Header as='h2' color='blue' textAlign='center'>
                        You can contact us @ 0757 477 399 (Call Or Whatsapp)
                </Header>
                </Grid.Column>
            </Grid>
        </div>
        : <p></p>
    )
}

export function ErrorMessages(props) {

    const errorList = props.formErrors.map((error) =>
        <Message.Item key={error}>{error}</Message.Item>
    );

    return (
        props.formHasError ?
            <Message negative>
                <Message.Header>Sorry Error With Your Submission</Message.Header>
                <Message.List >
                    {errorList}
                </Message.List>
            </Message>
            : <h6></h6>
    )
}

export function ShirtTypeRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (
        <div>
            <RadioGroupHeader
                radioGroupHeader={'Shirt Type:'}
                checkValue={props.checkValue}
                error={props.radioGroupError}
                errorMessage={'Please Select a Shirt Type'} />
            <br />
            {/* <Form.Field>
                <h4>Shirt Type: <b>{props.checkValue}</b></h4>
            </Form.Field> */}
            <Form.Group inline>

                {/* red */}
                <OrderFormRadioButton
                    label='Round Neck'
                    name='shirtType'
                    value='round_neck'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* v_neck */}
                <OrderFormRadioButton
                    label='V Neck'
                    name='shirtType'
                    value='v_neck'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* collar */}
                <OrderFormRadioButton
                    label="Collar / Polo"
                    name='shirtType'
                    value='collar'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />


            </Form.Group>
        </div>
    )
}

export function ShirtColorsRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (
        <div>
            <RadioGroupHeader
                radioGroupHeader={'Shirt Color:'}
                checkValue={props.checkValue}
                error={props.radioGroupError}
                errorMessage={'Please Select a Shirt Color'} />
            <br />
            {/* <Form.Field>
                <h4>Shirt Color: <b>{props.checkValue}</b></h4>
            </Form.Field> */}
            <Form.Group inline>

                {/* red */}
                <OrderFormRadioButton
                    label='Red'
                    name='shirtColor'
                    value='red'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* blue  */}
                <OrderFormRadioButton
                    label='Blue'
                    name='shirtColor'
                    value='blue'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* YELLOW */}
                <OrderFormRadioButton
                    label='Yellow'
                    name='shirtColor'
                    value='yellow'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />

                {/* YELLOW */}
                <OrderFormRadioButton
                    label='Black'
                    name='shirtColor'
                    value='black'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />

                {/* White */}
                <OrderFormRadioButton
                    label='White'
                    name='shirtColor'
                    value='white'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />

            </Form.Group>
        </div>
    )
}

/**
 * DISPLAYS THE HEADER OF EACH RADIO GROUP
 * @param {*} props 
 */
function RadioGroupHeader(props) {

    const errorDisplay = props.error
        ? <Message negative>
            <Message.Header>{props.errorMessage}</Message.Header>
        </Message>
        : <h7></h7>

    return (
        <div>
            <Form.Field>
                <h4>{props.radioGroupHeader}<b>{props.checkValue}</b></h4>
            </Form.Field>
            {errorDisplay}
        </div>
    )
}

export function ShirtSizesRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (
        <div>
            <RadioGroupHeader
                radioGroupHeader={'Shirt Size:'}
                checkValue={props.checkValue}
                error={props.radioGroupError}
                errorMessage={'Please Select a Shirt Size'} />
            <br />
            <Form.Group inline>

                {/* SMALL RADIO BUTTON */}
                <OrderFormRadioButton
                    label='Small'
                    name='shirtSize'
                    value='small'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* MEDIUM RADIO BUTTON */}
                <OrderFormRadioButton
                    label='Medium'
                    name='shirtSize'
                    value='medium'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent}
                />

                {/* LARGE RADIO BUTTON */}
                <OrderFormRadioButton
                    label='Large'
                    name='shirtSize'
                    value='large'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />

                {/* XLARGE RADIO BUTTON */}
                <OrderFormRadioButton
                    label='X-Large'
                    name='shirtSize'
                    value='x_large'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />

                {/* XXLARGE RADIO BUTTON */}
                <OrderFormRadioButton
                    label='XX-Large'
                    name='shirtSize'
                    value='xx_large'
                    checkValue={props.checkValue}
                    handleChangeInMainComponent={props.handleChangeInMainComponent} />
            </Form.Group>
        </div>
    )
}

// RADIO BUTTON OBJECT
export class OrderFormRadioButton extends Component {
    constructor(props) {
        super(props);
        console.log("orx2 OrderFormRadioButton constructor:" + props.checkValue);
        // this.handleChangeInsideComponent = this.handleChangeInsideComponent.bind(this);
    }

    handleChangeInsideComponent = (e, { name, value }) => {
        //handleChangeInsideComponent (e){
        console.log("inx1 button handleChangeInsideComponent ");
        console.log("inx12 value:" + value);
        console.log("inx13 name:" + name);
        this.props.handleChangeInMainComponent(e, { name, value });
    }

    render() {
        return (
            <Form.Field>
                <Radio
                    label={this.props.label}
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.props.checkValue === this.props.value}
                    onChange={this.handleChangeInsideComponent}
                />
            </Form.Field>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/OrderFormComps.js